<template>
  <div>
    <b-card title="">
      <custom-g-table
        v-if="displayTable"
        ref="custom-table"
        :displayLoading="tableLoading"
        :fields="fields"
        :items="data"
        :totalRows="totalRows"
        :limit="limit"
        :hasResendButton="true"
        @changePage="onChangePage"
        @onSortChange="onSortChange"
        @onColumnFilter="onFilter"
        @onResend="onResend"
      />
    </b-card>
  </div>
</template>

<script>
import { BCard } from "bootstrap-vue";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import sendpushService from "@/providers/sendpushService";
import dropdownService from "@/providers/dropdownService";
import { setRouteQuery, buildParamsRouteQuery } from "@/helpers/route-query-helper";
import { onlyLatestRequest } from "@/helpers/latest-request-helper";

export default {
  props: {
    urlQuery: Object
  },
  components: {
    BCard,
    CustomGTable,
    // CustomFilter,
  },
  data() {
    return {
      displayTable: false,
      sortField: {},
      data: [],
      totalRows: 0,
      limit: 50,
      page: 1,
      filter: {},
      tableLoading: true,
      fields: [
        // { field: "action_buttons", label: "Ações", sortable: false },
        {
          field: "dt_create",
          label: "Criação",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por data",
            trigger: "enter",
          },
        },
        {
          field: "dt_sent",
          label: "Data de Envio",
          type: "custom_date",
          sortable: true,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por data envio",
            trigger: "enter",
          },
        },
        { field: "sent", 
          label: "Enviado", 
          type: "boolean", 
          sortable: false, 
          filterOptions: { 
            filterValue: '', 
            enabled: true, 
            placeholder: 'Pesquisar por Enviado', 
            filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] } },
        {
          field: "title",
          label: "Título",
          sortable: false,
          filterOptions: {
            filterValue: '',
            enabled: true,
            placeholder: "Pesquisar por título",
            trigger: "enter",
          },
        },
        { field: "config", 
          label: "Custom", 
          type: "object", 
          object_field: "data", 
          sortable: false, 
        },
        { field: "config", 
          label: "Device_ID", 
          type: "object", 
          object_field: "devices", 
          sortable: false, 
        },
        { field: "clients", 
          label: "Device_ID", 
          type: "array", 
          sortable: false, 
        },

      ],
      origins: [],
    };
  },
  mounted() {
    this.$store.dispatch("admin/updatePageTitle", "Push");
    this.loadData();
  },
  computed: {
    searchParams() {
      const params = buildParamsRouteQuery(this.$route.query);
      params.append("page", this.page);
      params.append("limit", this.limit);

      if (this.sortField.field) {
        params.append(`sort_${this.sortField.field}`, this.sortField.type);
      }

      return params;
    },
  },
  methods: {
    onResend() {
      // todo resend push
    },
    setInitialTableFilters() {
      Object.keys(this.urlQuery).forEach(item => {
        this.fields[this.fields.findIndex(val => val.field==item)].filterOptions.filterValue = this.urlQuery[item];
      });
      this.loadData();
    },
    reportData() {
      const params = this.searchParams;
      params.append("download", true);
      sendpushService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'sendpush.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((err) => console.log(err));
    },
    onChangePage(page) {
      this.page = page;
      this.loadData();
    },
    onFilter(data) {
      // this.filter = data;
      // console.log("OnFilter: ", data);
      setRouteQuery(data, this.$route.query);
      this.loadData();
    },
    loadDataFilter() {
      Promise.all([
        dropdownService.getPushAction(new URLSearchParams()),
        dropdownService.getPushName(new URLSearchParams()),
      ])
        .then((res) => {
          this.fields[
            this.fields.findIndex((item) => item.field == "action")
          ].filterOptions.filterDropdownItems = res[0].map((item) => {
            return { value: item, text: item };
          });
          this.fields[
            this.fields.findIndex((item) => item.field == "name")
          ].filterOptions.filterDropdownItems = res[1].map((item) => {
            return { value: item, text: item };
          });
          this.setInitialTableFilters();
        })
        .catch((err) => console.log(err));
    },
    loadData() {
      this.data = [];
      this.tableLoading = true;
      // this.$refs['custom-table'].rows = [];
      // this.$refs['custom-table'].isLoading = true;
      onlyLatestRequest(this, 'loadData', sendpushService.getall(this.searchParams))
        .then((res) => {
          this.displayTable = true;
          this.data = res.data;
          this.totalRows = res.totalRows;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.displayTable = true;
          console.log(err);
        });
    },
    onSortChange(params) {
      this.sortField = params;
      this.loadData();
    },
  },
};
</script>

<style>
</style>